import { httpsCallable } from 'firebase/functions';
import { CloudFunctions } from '../utils/firebase/firebase';

export const fetchAllTeachers = async (uid, typeOfUser) => {
  try {
    const getAllTeachers = httpsCallable(CloudFunctions, 'allTeachers');
    const response = await getAllTeachers({
      uid,
      typeOfUser,
    });

    if (response.data.status) {
      return response.data;
    } else {
      return response;
    }
  } catch (e) {
    console.log('Error in fetchAllTeachers API: ', e);
    throw e;
  }
};

export const fetchingTeachersAndStudentsListForSchoolAdmin = async (uid) => {
  try {
    const fetchTeachersAndStudents = httpsCallable(
      CloudFunctions,
      'fetchingTeachersAndStudentsListForSchoolAdmin'
    );
    const response = await fetchTeachersAndStudents({ uid });

    // Handle the response
    if (response.data.status) {
      return response.data.data;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error during fetching teachers and students list:', error);
    throw error;
  }
};

export const fetchingTeachersForStudents = async (uid) => {
  try {
    const fetchingTeachersListForStudents = httpsCallable(
      CloudFunctions,
      'fetchingTeachersListForStudents'
    );
    const response = await fetchingTeachersListForStudents({ uid });

    // Handle the response
    if (response.data.status) {
      return response.data.data;
    } else {
      console.log('Failed to fetch students list:', response.data.message);
      return null;
    }
  } catch (error) {
    console.error('Error during fetching students list:', error);
    throw error;
  }
};

export const fetchingStudentsForTeachers = async (uid) => {
  try {
    const fetchingStudentsListForTeachers = httpsCallable(
      CloudFunctions,
      'fetchingStudentsListForTeachers'
    );
    const response = await fetchingStudentsListForTeachers({ uid });

    // Handle the response
    if (response.data.status) {
      return response.data.data;
    } else {
      console.log('Failed to fetch students list:', response.data.message);
      return null;
    }
  } catch (error) {
    console.error('Error during fetching students list:', error);
    throw error;
  }
};

export const getPreRegisteredUserForTeacher = async (uid) => {
  try {
    const fetchPreRegisteredUsersForTeachers = httpsCallable(
      CloudFunctions,
      'fetchPreRegisteredUsersForTeachers'
    );
    const response = await fetchPreRegisteredUsersForTeachers({ uid });

    if (response.data.status) {
      return response.data.data;
    } else {
      console.log(
        'Failed to fetch Pre-Registered Users For Teachers list:',
        response.data.message
      );
      return null;
    }
  } catch (error) {
    console.error(
      'Error during fetching Pre-Registered Users For Teachers list:',
      error
    );
    throw error;
  }
};

export const fetchAllTeacherClassRooms = async (uid) => {
  try {
    const getAllClassRooms = httpsCallable(
      CloudFunctions,
      'fetchingTeacherClassrooms'
    );
    const response = await getAllClassRooms({
      uid,
    });
    if (response.data.status) {
      return response.data;
    } else {
      return response;
    }
  } catch (e) {
    console.log('Error in fetch All Teachers Classroom  API: ', e);
    throw e;
  }
};

export const updateTeacherToSchoolAdmin = async (uid) => {
  try {
    const updateTeacherForSchoolAdmin = httpsCallable(
      CloudFunctions,
      'updateTeacherAsSchoolAdmin'
    );

    const response = await updateTeacherForSchoolAdmin({
      uid,
    });
    if (response.data.status) {
      return response.data.data;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const updateSchoolAdminToTeacher = async (uid) => {
  try {
    const updateSchoolAdminForTeacher = httpsCallable(
      CloudFunctions,
      'updateSchoolAdminAsTeacher'
    );

    const response = await updateSchoolAdminForTeacher({
      uid,
    });
    if (response.data.status) {
      return response.data.data;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const fetchTeachersDataForTeacherWithSchoolId = async (
  uid,
  schoolId,
  organizationId
) => {
  try {
    const fetchTeachersDataForTeacherWithSchoolId = httpsCallable(
      CloudFunctions,
      'fetchTeachersDataForTeacherWithSchoolId'
    );

    const response = await fetchTeachersDataForTeacherWithSchoolId({
      uid,
      schoolId,
    });

    if (response.data.status) {
      return response.data.data;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const fetchingTeachersForMultipleStudents = async (studentIds) => {
  try {
    const fetchingTeachersForMultipleStudents = httpsCallable(
      CloudFunctions,
      'fetchingTeachersForMultipleStudents'
    );
    const response = await fetchingTeachersForMultipleStudents({ studentIds });

    // Handle the response
    if (response.data.status) {
      return response.data.data;
    } else {
      console.log(
        'Failed to fetch teachers for multiple students:',
        response.data.message
      );
      return null;
    }
  } catch (error) {
    console.error(
      'Error during fetching teachers for multiple students:',
      error
    );
    throw error;
  }
};

export const fetchCustomizedPeriodsListForTeacher = async (teacherId) => {
  try {
    const fetchCustomizedPeriodsListForTeacher = httpsCallable(
      CloudFunctions,
      'fetchCustomizedPeriodsListForTeacher'
    );

    const response = await fetchCustomizedPeriodsListForTeacher({
      teacherId,
    });

    if (response.data.status) {
      return response.data.periodsData;
    } else {
      console.warn(
        'Failed to fetch customized periods:',
        response.data.message
      );
      return null;
    }
  } catch (e) {
    console.error('Error fetching customized periods:', e);
    throw e;
  }
};

export const updateTeacherCustomizedPeriods = async (
  uid,
  teacherId,
  periodDocId,
  periodData
) => {
  try {
    const updateTeacherCustomizedPeriods = httpsCallable(
      CloudFunctions,
      'updateTeacherCustomizedPeriods'
    );

    const response = await updateTeacherCustomizedPeriods({
      uid,
      teacherId,
      periodDocId,
      periodData,
    });

    if (response.data.status) {
      return response.data.message;
    } else {
      console.warn(
        'Failed to update customized periods:',
        response.data.message
      );
      return null;
    }
  } catch (e) {
    console.error('Error updating customized periods:', e);
    throw e;
  }
};

export const getCustomizedDataEntrySectionsForTeacher = async (schoolId) => {
  try {
    console.log(
      'getCustomizedDataEntrySectionsForTeacher API called with schoolId:',
      schoolId
    );

    const getCustomizedDataEntrySectionsForTeacher = httpsCallable(
      CloudFunctions,
      'getCustomizedDataEntrySectionsForTeacher'
    );

    const response = await getCustomizedDataEntrySectionsForTeacher({
      schoolId,
    });

    console.log('API response:', response.data);

    if (response.data.status) {
      console.log('API returning data:', response.data.dataEntrySectionsData);
      // return response.data.dataEntrySectionsData;
      return Array.isArray(response.data.dataEntrySectionsData)
        ? response.data.dataEntrySectionsData
        : [];
    } else {
      console.warn(
        'Failed to fetch customized data entry sections:',
        response.data.message
      );
      // return null;
      return [];
    }
  } catch (e) {
    console.error('Error fetching customized data entry sections:', e);
    throw e;
  }
};

export const updateTeacherCustomizedDataEntrySections = async (
  uid,
  schoolId,
  dataEntryData
) => {
  try {
    const updateTeacherCustomizedDataEntrySections = httpsCallable(
      CloudFunctions,
      'updateTeacherCustomizedDataEntrySections'
    );

    const response = await updateTeacherCustomizedDataEntrySections({
      uid,
      schoolId,
      dataEntryData,
    });

    if (response.data.status) {
      return response.data.message;
    } else {
      console.warn(
        'Failed to update customized data entry sections:',
        response.data.message
      );
      return null;
    }
  } catch (e) {
    console.error('Error updating customized data entry sections:', e);
    throw e;
  }
};